export default {
  // API_URL: 'http://localhost:2407/api',
  // OAPI_URL: 'http://localhost:2407/oapi',
  API_URL: "https://api-integracaofetag.infinitum-ti.com/api",
  OAPI_URL: "https://api-integracaofetag.infinitum-ti.com/oapi",
};
